import React, { useEffect, useState, useRef } from 'react';
import { API_ENDPOINTS } from "../../../util/constants";
import { getUserApiKey, getAccountId } from "../../../util/helpers";
import axios from "axios";
import { setSnackbar } from "../../../../redux/snackbar";
import { FormattedMessage } from "react-intl";
import { Card, CardBody } from "../../../../Utils/_partials/controls";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Overlay, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../../Utils/_helpers";

function ClipWithTip(props) {
    const [show, _setShow] = useState(false);
    const target = useRef(null);

    const setShow = (v) => {
        _setShow(v);
        if (v) {
            setTimeout(() => {
                _setShow(false);
            }, 1000);
        }
    };

    return (
        <>
            <CopyToClipboard
                text={props.text}
                onCopy={() => {
                    setShow(true);
                }}
            >
                <img
                    alt=""
                    ref={target}
                    onClick={() => setShow(!show)}
                    className="copy-icn"
                    src={toAbsoluteUrl("/media/sr/icons/crm/copy.svg")}
                />
            </CopyToClipboard>
            <Overlay target={target.current} show={show} placement="right">
                {(props) => (
                    <Tooltip id="overlay-example" {...props}>
                        Copied to clipboard.
                    </Tooltip>
                )}
            </Overlay>
        </>
    );
}

const ApiKeyDisplay = ({ apiKey, isDefault }) => {
    const containerStyle = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'left',
    };

    const textStyle = {
        margin: '5px 0',
        fontSize: '18px',
    };

    return (
        <div className="col-auto mr-auto pr-2 pl-5 mb-3 mt-3">
            <div className="row dash-title-row">
                <div className="col-auto mr-auto pr-2 pl-5 mb-3">
                    <span className="title-text" style={{ fontSize: "18px" }}>
                        <FormattedMessage id="x-api" defaultMessage="X-API" />
                    </span>
                </div>
            </div>

            <div className="row">
                <div className="col-12 col-md-12 col-lg-12 pl-5 pr-2">
                    <Card className="custom-card-style h-100">
                        <CardBody>
                            <div className="d-flex flex-row justify-content-between ">
                                <div className="col-4 col-lg-3">
                                    <span
                                        className="card-body-title"
                                        style={{ whiteSpace: "pre", fontSize: "18px" }}
                                    >
                                        {/* <FormattedMessage id="x-api-key" defaultMessage="X-API" /> */}
                                    </span>
                                </div>
                            </div>
                            <div style={containerStyle}>
                                <div style={textStyle}>X-API-Key: {apiKey} <ClipWithTip text={apiKey || 'None'} /></div>
                                <div style={textStyle}>Default X-API-Key: {isDefault ? 'Yes' : 'No'}</div>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            </div>
        </div>
    );
};

// Updated component name to DeveloperDocs
export function DeveloperDocs() {
    const [apiKey, setApiKey] = useState('');
    const [isDefault, setIsDefault] = useState(false);

    useEffect(() => {
        // Define the API call function
        const fetchApiKey = async () => {
            try {
                const response = await axios.get(API_ENDPOINTS.getDeveloperKey);
                if (response && response.data && response.data.length > 0) {
                    // Assuming we want the first API key in the response
                    const firstUser = response.data[0];
                    setApiKey(firstUser.aws_api_key);
                    setIsDefault(firstUser.is_default);
                }
            } catch (error) {
                setSnackbar(true, "error", error?.response?.data?.error);
            }
        };

        // Call the API function when the component mounts
        fetchApiKey();
    }, []);

    return (
        <div>
            <ApiKeyDisplay apiKey={apiKey} isDefault={isDefault} />
            {/* Rest of your page content */}
        </div>
    );
}
